import { c as _c } from "react/compiler-runtime";
import type { SkillFileNode } from '@onefootprint/request-types/dashboard';
import { createContext, type ReactNode, useContext } from 'react';
import type { SkillsActions } from '../utils/build-skills-actions';
type SkillEditor = {
  skills: SkillFileNode[];
  selectedPath: string | null;
  isReadOnly: boolean;
  actions: SkillsActions;
  /** Persists edits that `rename` and `setContent` applied without saving. */
  commit: () => void;
};
const SkillEditorContext = createContext<SkillEditor | null>(null);
type SkillEditorProviderProps = {
  value: SkillEditor;
  children: ReactNode;
};
const SkillEditorProvider = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <SkillEditorContext.Provider value={value}>{children}</SkillEditorContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const useSkillEditor = () => {
  const editor = useContext(SkillEditorContext);
  if (!editor) {
    throw new Error("useSkillEditor must be used inside a SkillEditorProvider");
  }
  return editor;
};
export type { SkillEditor };
export { SkillEditorProvider, useSkillEditor };